var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"li-view",attrs:{"params":_vm.params,"query":_vm.query},on:{"submit":_vm.handleSubmit,"cancel":_vm.handleCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }